<template>
  <div v-if="screenWidth > 1219" class="minting">
    <div class="Container">
      <div class="minting-top">
        <div class="item1">
          <span class="minting-title">Stake your VSYS to earn</span>
          <span class="minting-content"
            >All VSYS coin holders can participate in Supernode minting and be
            rewarded with VSYS coins. Fast and easy, no coin lock-up.</span
          >
          <div class="link_box">
            <a
              class="minting-link minting-video"
              href="https://www.youtube.com/watch?v=4nNrNBcXIbQ&t=3s"
              target="_blank"
              >Tutorial</a
            >
            <a
              class="minting-link minting-how"
              href="/wiki/vsys-coin-leasing.html"
              target="_blank"
              >How to participate in minting?</a
            >
          </div>
        </div>

        <div class="item2 itemVsys">
          <a
            href="https://www.youtube.com/watch?v=wwukiFsUsq0"
            target="_blank"
            class="play"
          ></a>
        </div>

        <div class="item2 itemVsysrate">
          <a
            href="https://www.youtube.com/watch?v=4nNrNBcXIbQ"
            target="_blank"
            class="play"
          ></a>
        </div>

        <el-dialog
          :visible.sync="dialogVisible"
          width="50%"
          :before-close="handleClose"
        >
          <div>这里放视频</div>
        </el-dialog>
      </div>

      <div class="minting-top">
        <!-- <a target="_blank" href="https://forum.v.systems/t/staking-club-vsys/176"><img src="../../assets/stakingclub_pc.jpg"/></a>

        <a target="_blank" href="https://forum.v.systems/t/greetings-from-forbole-v-the-new-supernode/335"><img src="../../assets/img_banner_forbole_pc.png"/></a>

        <a target="_blank" href="https://www.okex.com/pool/lock/index"><img src="../../assets/img_banner_okex_pool_pc.png"/></a>

        <a target="_blank" href="https://forum.v.systems/t/hellovsys-enjoy-the-exclusive-minting-experience-here/198"><img src="../../assets/hello_vsys_pc.jpg"/></a> -->
      </div>
    </div>
    <div class="noticeContainer">
      <div class="notice">
        <img class="announceImg" src="../../assets/ic_announce.svg" />

        <a
          href="https://medium.com/vsystems/how-to-create-a-new-account-on-titan-wallet-5556985da07c"
          target="_blank"
          class="noticeItem"
        >
          <el-tooltip
            effect="light"
            content="How to create a new account on Titan Wallet"
            placement="top"
          >
            <div class="content">
              <strong>Create a new account</strong>
            </div>
          </el-tooltip>
          <div class="time">03-29</div>
        </a>

        <a
          href="https://medium.com/vsystems/ultimate-guide-to-staking-with-vsys-wallets-12ca3102a212"
          target="_blank"
          class="noticeItem"
        >
          <el-tooltip
            effect="light"
            content="Ultimate Guide to Staking with VSYS Wallets"
            placement="top"
          >
            <div class="content">
              <strong>Stake VSYS</strong>
            </div>
          </el-tooltip>
          <div class="time">03-13</div>
        </a>

        <a
          href="https://medium.com/vsystems/swap-between-vsys-and-usdt-in-just-a-few-clicks-0d7c45883df8"
          target="_blank"
          class="noticeItem"
        >
          <el-tooltip
            effect="light"
            content="Swap between VSYS and USDT in just a few clicks"
            placement="top"
          >
            <div id="notice1" class="content">
              <strong>Swap VSYS-USDT</strong>
            </div>
          </el-tooltip>
          <div class="time">06-12</div>
        </a>

        <a
          href="https://medium.com/vsystems/1h-2024-recap-v-systems-2fcd5f6f36a4"
          target="_blank"
          class="noticeItem"
        >
          <el-tooltip
            effect="light"
            content="1H 2024 Recap — V Systems"
            placement="top"
          >
            <div class="content">
              <strong>1H 2025 Recap</strong>
            </div>
          </el-tooltip>
          <div class="time">07-09</div>
        </a>

        <a href="https://medium.com/vsystems" target="_blank" class="noticeMore"
          >More</a
        >
      </div>
    </div>
  </div>
  <div v-else class="mminting">
    <!-- <el-carousel trigger="click" height="1.6rem" :interval="5000" >
      <el-carousel-item key="1">
        <a target="_blank" href="https://forum.v.systems/t/staking-club-vsys/176"><img src="../../assets/stakingclub_mobile.jpg"/></a>
      </el-carousel-item>
      <el-carousel-item key="2">
        <a target="_blank" href="https://forum.v.systems/t/greetings-from-forbole-v-the-new-supernode/335"><img src="../../assets/img_banner_forbole_mobile.png"/></a>
      </el-carousel-item>
      <el-carousel-item key="3">
        <a target="_blank" href="https://www.okex.com/pool/lock/index"><img src="../../assets/img_banner_okex_pool_mobile.png"/></a>
      </el-carousel-item>
      <el-carousel-item key="4">
        <a target="_blank" href="https://forum.v.systems/t/hellovsys-enjoy-the-exclusive-minting-experience-here/198"><img src="../../assets/hello_vsys_mobile.jpg"/></a>
      </el-carousel-item>
    </el-carousel> -->
  </div>
</template>
<style></style>
<script>
export default {
  name: 'Minting',

  data() {
    return {
      dialogVisible: false,
      screenWidth: window.screen.width,
      items: [1, 2, 3, 4],
    };
  },

  methods: {
    handleClose(done) {
      done();
    },
  },
};
</script>

<style lang="scss">
.Container {
  overflow: hidden;
}

.el-tooltip__popper {
  font-size: 14px !important;
}

.noticeContainer {
  background-color: white;
  height: 40px;
  width: 100%;
  margin-top: 20px;
  border-bottom: 1px solid #f2f2f5;

  .notice {
    width: 1220px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    font-size: 14px;
  }

  .announceImg {
    width: 16px;
    height: 15px;
  }

  .noticeItem {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    // width: 320px;
    width: 250px;
    white-space: nowrap;
  }
  .content {
    // width: 270px;
    // width: 170px;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #323233;
  }
  .time {
    color: #afafb3;
    margin-left: 20px;
  }
  .noticeMore {
    color: #ff8837;
  }
  .noticeMore:after {
    content: " ";
    width: 12px;
    height: 8px;
    background: url("../../assets/ic_arrow_right.svg");
    background-size: contain;
    display: inline-block;
    margin-left: 8px;
  }
}
.minting {
  // height: 290px;
  // height: 310px;
  background: #f7f7fa;
  min-width: 1240px;
  margin-bottom: 40px;

  img {
    width: 290px;
  }
  &-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .item1 {
      width: 600px;
      display: flex;
      flex-direction: column;

      .link_box {
        display: flex;
      }
    }
    .item2 {
      width: 290px;
      height: 140px;
      cursor: pointer;

      .play {
        width: 44px;
        height: 30px;
        background: url("../../assets/ic_youtube_play.png");
        background-size: contain;
        background-repeat: no-repeat;
        filter: drop-shadow(0 4px 12px rgba(50, 50, 51, 0.1));
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        display: block;
      }
    }
    .itemVsys {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url("../../assets/video_cover_vsys.png");
    }
    .itemVsysrate {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url("../../assets/video_cover_vsysrate.png");
      margin-left: 20px;
    }
  }
  &-title {
    font-size: 36px;
    display: block;
    font-family: Verdana-Bold, sans-serif;
    color: #323233;
    margin-bottom: 10px;
  }
  &-content {
    font-size: 15px;
    color: #7d7d80;
    display: block;
    margin-bottom: 20px;
    line-height: 20px;
  }
  &-link {
    font-size: 17px;
    color: #ff8837;
    margin-right: 58px;
    margin-left: 16px;
    // &::after{
    //   content: ' ';
    //   background: url('../../assets/ic_arrow_next.svg');
    //   width: 16px;
    //   height: 6px;
    //   background-size: cover;
    //   display: inline-block;
    //   position: relative;
    //   left: 10px;
    //   bottom: 2px;
    // }
  }
  &-video::before {
    content: " ";
    background: url("../../assets/ic_video_line_yellow.svg");
    width: 20px;
    height: 16px;
    background-size: cover;
    display: inline-block;
    position: relative;
    right: 10px;
    top: 2px;
  }
  &-how::before {
    content: " ";
    background: url("../../assets/ic_help_line_yellow.svg");
    width: 16px;
    height: 16px;
    background-size: cover;
    display: inline-block;
    position: relative;
    right: 10px;
    top: 2px;
  }
}
.mminting {
  // height: 1.6rem;

  .el-carousel__item a {
    display: block;
    height: 100%;
  }
  .el-carousel__item img {
    width: 3.75rem;
    height: 1.6rem;
  }
  .el-carousel__button {
    width: 0.05rem;
    height: 0.05rem;
    border-radius: 50%;
  }
  .el-carousel__indicators {
    height: 0.3rem;
    display: flex;
  }
  .el-carousel__indicator {
    display: block;
  }
}
</style>
